<template>
  <div class="wc-navbar bg-primary">
    <section v-if="isNotAnEmployee" class="container-xl px-3">
      <ul
        v-if="
          isNotAnEmployee &&
            ((getMenu && getMenu.children) || (circularMenu && circularMenu.length))
        "
        class="wc-item-group-menu nav"
      >
        <WCItemGroupsMenu
          :menu="getMenu"
          :wcHeaderHeight="wcHeaderHeight"
          v-if="$route.name !== 'Gift Card'"
          :circularMenu="circularMenu"
        />
      </ul>
    </section>
  </div>
</template>

<script>
import axios from 'axios';

import WCItemGroupsMenu from '@/components/WCItemGroupsMenu/WCItemGroupsMenu.vue';
import EmployeeMixin from '@/modules/employee/mixins/EmployeeMixin';
import ItemGroupMixin from '../../modules/filters/mixins/ItemGroupMixin';

export default {
  name: 'WCNavBar',
  components: { WCItemGroupsMenu },
  mixins: [ItemGroupMixin, EmployeeMixin],
  props: {
    wcHeaderHeight: {
      required: false,
      type: String,
      default: '0px',
    },
  },
  data() {
    return {
      circularMenu: [],
    };
  },
  async created() {
    await this.getCircularData(); // Fetch circular data - specials and promotions
  },
  methods: {
    /**
     * Method to fetch circulars for specials and promotions
     */
    async getCircularData() {
      try {
        const response = await axios.get('/api/circulars');
        this.circularMenu = response?.data?.data;
      } catch (error) {
        console.error(error);
      }
    },
  },
  computed: {
    getMenu() {
      return this.$configuration.mainMenu;
    },
    /**
     * Construct circular menu items object
     */
    circularMenuItems() {
      return {
        name: this.$t('currentSpecials'),
        children: this.circularMenu,
      };
    },
  },
};
</script>

<style scoped lang="scss">
@import '~@/assets/styles/tools';
@import '~@/assets/styles/settings';

ul li:first-child > :deep(a) {
  padding-left: 0;
}

.wc-navbar {
  min-height: 2.5rem;
}

.wc-navbar :deep(.wc-item-group-menu),
.wc-navbar :deep(.nav-item),
.wc-navbar :deep(.dropdown) {
  min-height: 2.5rem;
}

.wc-navbar :deep(.nav-link) {
  display: inline-flex;
  align-items: center;
  min-height: 2.5rem;
  padding-top: 0;
  padding-bottom: 0;
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 400;
  color: var(--white, $white);
  line-height: 1;

  strong {
    font-weight: 700;
  }

  &:hover,
  &:focus {
    color: var(--white, $white);
  }
}

.wc-navbar :deep(.dropdown-menu) {
  margin: 0;
  border-radius: 0 0 0.375rem 0.375rem;
  border: none;
}

.wc-navbar :deep(.dropdown-item) {
  font-size: $font-size-base;
}
</style>
